import lf from 'lovefield'

export function const_famillesengins (schemaBuilder) {
  schemaBuilder.createTable('const_famillesengins')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('description', lf.Type.STRING)
      .addPrimaryKey(['id'])
      // .addUnique('code', ['code'])
}


/*
CREATE TABLE IF NOT EXISTS `const-famillesengins` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `code` varchar(4) NOT NULL,
  `nom` varchar(30) NOT NULL,
  `description` text NOT NULL,
  PRIMARY KEY (`id`),
  UNIQUE KEY `code` (`code`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=16 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constFamillesengins.schema.js